import React from 'react';
import './Gallery.css'

const Gallery = () => {
    return (
        <div> 
            <h1 className='text-center mb-5'>GALLERY</h1>
            <div className='gallery-section mb-5'>
                <img src="https://i.ibb.co/tsSyqLv/pexels-rhiannon-stone-694274.jpg" alt="" />
                <img src="https://i.ibb.co/ZLDmPmK/pexels-ph-m-t-ng-709496.jpg" alt="" />
                <img src="https://i.ibb.co/7SX0vBn/pexels-mihai-vlasceanu-4624080.jpg" alt="" />
                <img src="https://i.ibb.co/vd5Z9Z0/pexels-nuwan-chamara-3087240.jpg" alt="" />
                <img src="https://i.ibb.co/SV5Lq1n/pexels-min-an-953717.jpg" alt="" />
                <img src="https://i.ibb.co/0DXdXjx/pexels-jasmine-carter-888919.jpg" alt="" />
                <img src="https://i.ibb.co/hBr904R/pexels-alexander-kalelov-398524.jpg" alt="" />
                <img src="https://i.ibb.co/chvbkQY/pexels-jos-van-ouwerkerk-1617365.jpg" alt="" />
            </div>
        </div>
    );
};

export default Gallery;